// Token refreshing is by design reactive.
// But if a user was on a other website an returns to this website we want to ensure token refreshing is awaited before checking the authentication
// eslint-disable-next-line no-restricted-exports
export default defineNuxtRouteMiddleware(async () => {
    const { refreshIfNecessary } = useTokenStore();

    await refreshIfNecessary();
});
